import React from "react";
import {
  Box,
  Button,
  Chip,
  Paper,
  Slider,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import { formatDay } from "./cashTimeline";

const MODE_NOTE = {
  sequenced:
    "Collect, then pay. Each vendor or payroll cost is settled only after the client has paid for the packet that earned it, so the cushion never goes below zero.",
  conventional:
    "Pay as work happens (comparison only). Payroll runs every 14 days for the days worked, material vendors take 30% at the start and 70% net-30 after delivery, subcontractors net-30. Collection from the client is unchanged — watch the cushion go red.",
};

/**
 * The timeline's cursor (play, or drag the slider / any chart) and the
 * payment-sequencing comparison.
 */
export default function CashTimelineControls({
  timeline,
  cursorDay,
  onCursorChange,
  isPlaying,
  onTogglePlay,
  mode,
  onModeChange,
}) {
  const isToday = cursorDay === timeline.todayDay;

  return (
    <Paper variant="outlined" sx={{ p: 1.5, display: "grid", gap: 1.5 }}>
      <Stack direction="row" alignItems="center" spacing={2} useFlexGap flexWrap="wrap">
        <Button
          size="small"
          variant="outlined"
          startIcon={isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          onClick={onTogglePlay}
        >
          {isPlaying ? "Pause" : "Play"}
        </Button>
        <Box sx={{ minWidth: 150 }}>
          <Typography variant="subtitle2" sx={{ fontVariantNumeric: "tabular-nums" }}>
            {formatDay(timeline, cursorDay)}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Day {cursorDay} · Week {Math.floor(cursorDay / 7) + 1}
          </Typography>
        </Box>
        {!isToday && (
          <Chip size="small" label="Back to today" onClick={() => onCursorChange(timeline.todayDay)} />
        )}
        <Slider
          size="small"
          min={0}
          max={timeline.days}
          value={cursorDay}
          onChange={(_event, day) => onCursorChange(day)}
          valueLabelDisplay="auto"
          valueLabelFormat={(day) => formatDay(timeline, day)}
          aria-label="Timeline day"
          sx={{ flex: 1, minWidth: 180 }}
        />
      </Stack>

      <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} alignItems={{ md: "center" }}>
        <ToggleButtonGroup
          size="small"
          exclusive
          value={mode}
          onChange={(_event, next) => next && onModeChange(next)}
          aria-label="Payment sequencing"
        >
          <ToggleButton value="sequenced">Chinook: collect, then pay</ToggleButton>
          <ToggleButton value="conventional">Conventional: pay as work happens</ToggleButton>
        </ToggleButtonGroup>
        <Typography variant="caption" color="text.secondary">
          {MODE_NOTE[mode]}
        </Typography>
      </Stack>
    </Paper>
  );
}
